import { useState, useEffect, useRef } from 'react'
import Select from "react-select";
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';

export default function RcaDropdowns({ onUpdateDropdownData, grupId, grupName, filterObject, dataJson }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const reactSelectStyles = {
    container: (provided, state) => ({
      ...provided,
      padding: 0,
      height: 'fit-content',
    }),
    control: (provided, state) => ({
      ...provided,
      borderWidth: 1,
      minHeight: 'fit-content',
      height: 'fit-content'
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '25px'
    }),
    input: (provided, state) => ({
      ...provided,
      height: '10px',
    })
  };

  const axisOptions = [
    { value: 'left', label: 'Left' },
    { value: 'right', label: 'Right' },
  ];

  const [ecu, setEcu] = useState(null);
  const [axis, setAxis] = useState(null);
  const [signal, setSignal] = useState(null);
  const [signalList, setSignalList] = useState([]);
  const [dataId, setDataId] = useState('1')

  const getSignalRes = (data) => {
    let tempArr = []
    data.forEach(element => {
      tempArr.push({ "name": element._source.pgspname, 'data-id': element._source.Frequency })
      // tempArr.push({ "name": element._source.pgspname, 'data-id': "25" })
    });
    setSignalList(tempArr);
  }

  const handleECUchange = (obj, idToRemove, grupName) => {
    fetchData({ url: API_URL_MAIN + "rca_ace/getSignal", body: { filterdata: filterObject, ecu: obj.region } }, getSignalRes)
    setEcu(obj);
    setSignal(null);
    let newObj = { "ecu": obj.region, "axis": axis, "signal": null, "elemntId": idToRemove, "dataId": dataId }
    onUpdateDropdownData(newObj, grupName)
  }

  const handleAXISchange = (obj, idToRemove, grupName) => {
    setAxis(obj.value);
    setSignal(null);
    let newObj = { "ecu": ecu.region, "axis": obj.value, "signal": null, "elemntId": idToRemove, "dataId": dataId }
    onUpdateDropdownData(newObj, grupName)
  }

  const handleSIGNALchange = (obj, idToRemove, grupName) => {
    setDataId(obj['data-id'])
    setSignal(obj);
    let newObj = { "ecu": ecu.region, "axis": axis, "signal": obj.name, "elemntId": idToRemove, "dataId": obj['data-id'] }
    onUpdateDropdownData(newObj, grupName)
  }

  return (
    <>
      <div className="row tempClsMain">
        <div className={grupName !== "C" ? "col-4 tempCla" : "col-4 tempCla"}>
          <Select
            styles={reactSelectStyles}
            placeholder="ECU"
            value={ecu}
            options={dataJson}
            onChange={(e) => handleECUchange(e, grupId, grupName)}
            getOptionLabel={x => x.region}
            getOptionValue={x => x.region} />
        </div>
        {
          grupName !== "C" &&
          <div className="col-3 tempCla">
            <Select
              styles={reactSelectStyles}
              placeholder="Axis"
              options={axisOptions}
              defaultValue={(grupName === "C") ? { value: 'left', label: 'Left' } : null}
              onChange={(e) => handleAXISchange(e, grupId, grupName)} />
          </div>
        }
        <div className={grupName !== "C" ? "col-5 tempCla" : "col-8 tempCla"}>
          <Select
            styles={reactSelectStyles}
            placeholder="Signal"
            value={signal}
            options={signalList}
            getOptionLabel={x => x.name}
            getOptionValue={x => x.name}
            onChange={(e) => handleSIGNALchange(e, grupId, grupName)} />
        </div>
      </div>
    </>
  )
}
